import styled from 'styled-components';

export const Wrapper = styled.div`
  position: relative;
  --aspect-ratio: 9 / 16;
  padding-bottom: calc(var(--aspect-ratio, 0.5625) * 100%);
  height: 0;
  width: 100%;
`;

export const Frame = styled.iframe`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
`;
